export const PROVIDERS = Object.freeze({
  CONNECTRIA: 'CONNECTRIA',
  LIGHTEDGE: "LIGHTEDGE",
});
